export const DemoSection = () => {
  return (
    <div>
      {/* Product Preview */}
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="transform overflow-hidden rounded-2xl shadow-xl transition-all duration-300 hover:scale-[1.02]">
          <img src="/chronology.png" alt="Paribus AI Interface" className="w-full" />
        </div>
      </div>

      {/* Main Features */}
      <div className="bg-background py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-16 lg:grid-cols-3">
            <div className="transform text-center transition-all duration-300 hover:scale-105">
              <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-primary-subtle">
                <svg
                  className="h-8 w-8 text-primary"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M13 10V3L4 14h7v7l9-11h-7z"
                  />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-foreground">Handle more cases</h3>
              <p className="mt-4 text-lg text-muted-foreground">
                Streamline medical document review and chronology creation. Let our AI handle the
                heavy lifting while you focus on your clients.
              </p>
            </div>
            <div className="transform text-center transition-all duration-300 hover:scale-105">
              <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-primary-subtle">
                <svg
                  className="h-8 w-8 text-primary"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-foreground">Focus on what matters</h3>
              <p className="mt-4 text-lg text-muted-foreground">
                Spend time where it counts most: with your clients and in the courtroom. Let Paribus
                handle the document analysis.
              </p>
            </div>
            <div className="transform text-center transition-all duration-300 hover:scale-105">
              <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-primary-subtle">
                <svg
                  className="h-8 w-8 text-primary"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                  />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-foreground">Don't miss a thing</h3>
              <p className="mt-4 text-lg text-muted-foreground">
                Our Human QA team proactively identifies missing documents, red flags, and potential
                case issues before they become problems.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
